/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type DiscoveryProfileIdsQueryVariables = Types.Exact<{
  interests: Array<Types.Scalars["String"]> | Types.Scalars["String"];
  weekendPace: Array<Types.Scalars["Int"]> | Types.Scalars["Int"];
  teammatesNeeded: Array<Types.Scalars["Int"]> | Types.Scalars["Int"];
  query?: Types.Maybe<Types.DiscoveryProfileQueryInput>;
}>;

export type DiscoveryProfileIdsQuery = Pick<Types.Query, "discoveryProfileIds">;

export const DiscoveryProfileIdsDocument = gql`
  query DiscoveryProfileIds(
    $interests: [String!]!
    $weekendPace: [Int!]!
    $teammatesNeeded: [Int!]!
    $query: DiscoveryProfileQueryInput
  ) {
    discoveryProfileIds(
      interests: $interests
      weekend_pace: $weekendPace
      teammates_needed: $teammatesNeeded
      query: $query
    )
  }
`;

/**
 * __useDiscoveryProfileIdsQuery__
 *
 * To run a query within a React component, call `useDiscoveryProfileIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscoveryProfileIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscoveryProfileIdsQuery({
 *   variables: {
 *      interests: // value for 'interests'
 *      weekendPace: // value for 'weekendPace'
 *      teammatesNeeded: // value for 'teammatesNeeded'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useDiscoveryProfileIdsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    DiscoveryProfileIdsQuery,
    DiscoveryProfileIdsQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    DiscoveryProfileIdsQuery,
    DiscoveryProfileIdsQueryVariables
  >(DiscoveryProfileIdsDocument, baseOptions);
}
export function useDiscoveryProfileIdsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    DiscoveryProfileIdsQuery,
    DiscoveryProfileIdsQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    DiscoveryProfileIdsQuery,
    DiscoveryProfileIdsQueryVariables
  >(DiscoveryProfileIdsDocument, baseOptions);
}
export type DiscoveryProfileIdsQueryHookResult = ReturnType<
  typeof useDiscoveryProfileIdsQuery
>;
export type DiscoveryProfileIdsLazyQueryHookResult = ReturnType<
  typeof useDiscoveryProfileIdsLazyQuery
>;
export type DiscoveryProfileIdsQueryResult = ApolloReactCommon.QueryResult<
  DiscoveryProfileIdsQuery,
  DiscoveryProfileIdsQueryVariables
>;
